import React, { useContext } from 'react'
import RechartPie from './RechartPIE'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import R from 'ramda'
import { getFinalData } from 'marginanalysis/utils'

const CauseCodeGroupReChartPie = props => {
  const marginContext = useContext(MarginAnalysisContext)

  const { eventSummary = [] } = getFinalData(
    marginContext,
    props.whatIf || false,
    props.isEventPlanner || false
  )

  return (
    <CauseCodeGroupReChartPieGraph {...props} eventSummary={eventSummary} />
  )
}

const CauseCodeGroupReChartPieGraph = props => {
  const { actualHeight = 170, actualWidth = 1000, eventSummary = [] } = props
  const height = actualHeight
  const width = actualWidth

  const data = R.compose(
    // R.reduce((a,b)=>({...a,...b}),{}) ,
    R.addIndex(R.map)((d, i) => ({
      index: i,
      name: d.key,
      value: d.value,
      getLabel: ({ name }) => name,
    })),
    R.sortBy(d => d.key),
    R.map(d => ({
      key: d.causeDescrip,
      value:
        // parseFloat(d.lostOppMwh || 0) +
        // parseFloat(d.lostOppRevenue || 0) +
        parseFloat(d.lostOppMargin || 0),
    }))
  )(eventSummary)

  return (
    <RechartPie
      data={data}
      height={height}
      width={width}
      applyLableCalc
      outerRadius={props.outerRadius}
    />
  )
}

export default CauseCodeGroupReChartPie
export { CauseCodeGroupReChartPieGraph }
